import React, { useState } from "react";
import { Menu, Grid } from "antd";
import { useHistory } from "react-router-dom";
import { MenuItemReport , MenuItems , MenuItems2 } from "./MenuItems";

const { useBreakpoint } = Grid;

const LeftMenu = () => {
  const history = useHistory();

  const [itemlist, setitemlist] = useState([
    {
      label:"การจัดการ",
      children:[
        {
          key:MenuItems[0].path,
          label:MenuItems[0].title
        },
        {
          key:MenuItems[1].path,
          label:MenuItems[1].title
        },
        {
          key:MenuItems[2].path,
          label:MenuItems[2].title
        }
      ]
    },
    // {
    //   label:"การทำงาน",
    //   children:[
    //     {
    //       key:MenuItems2[0].path,
    //       label:MenuItems2[0].title
    //     },
    //   ]
    // },
    {
      label:"รายงาน",
      children:[
        {
          key:MenuItemReport[0].path,
          label:MenuItemReport[0].title
        },
        {
          key:MenuItemReport[1].path,
          label:MenuItemReport[1].title
        },
        {
          key:MenuItemReport[2].path,
          label:MenuItemReport[2].title
        },
      ]
    }
  ]);

  const [current, setCurrent] = useState("mail");
  const onClick = (e) => {
    setCurrent(e.key);
    handleClick();
    const urlGoBack = { pathname: e.key};
    setTimeout(history.push(urlGoBack), 1000);
  };

  const handleClick = (e) => {
  }
  const { lg } = useBreakpoint();

  return (
    <Menu
      onClick={onClick}
      selectedKeys={[current]}
      mode={lg ? "horizontal" : "inline"}
      items={itemlist}
    />
  );
};

export default LeftMenu;
